import { AISaasInputItem } from "./item";
import { useAiSaasInputContainer } from "./container";
import SortableList from "../SortableList/container/List";
import { useHomeUsePluginContainer } from "@custom-hooks/HomeUsePluginRoot";
import { useEffect } from "react";
import { WITHOUT_INPUT_ID } from "../AddToContent/conts";

export function AISaasInput() {
  const { sortableList, onChangeSaasUIInputData } = useAiSaasInputContainer();
  const {
    saasAndThinkState: {
      saasUIData,
      isAddInputNode,
      addContentId,
      setAddContentId,
      nextAddContentId,
      setNextAddContentId,
      setIsClickAddToContent,
    },
  } = useHomeUsePluginContainer();

  /**
   * 当addContentId对应的input node在preview中被移除时
   * 1、把nextAddContentId赋值给addContentId
   * 2、把已点击click here的状态重置
   *
   * 当nextAddContentId对应的input node在preview中被移除时
   * 1、nextAddContentId重新赋值，如果没有下一个则是undefined
   * */
  useEffect(() => {
    if (!isAddInputNode || addContentId === WITHOUT_INPUT_ID) return;
    const { input } = saasUIData;
    if (input?.every(item => item.id !== addContentId)) {
      //  当移除addContentId对应的node时
      setAddContentId(nextAddContentId);
      input.forEach((item, index, array) => {
        if (item.id === nextAddContentId) {
          setNextAddContentId(array[index + 1]?.id || WITHOUT_INPUT_ID);
        }
      });
    } else if (input?.every(item => item.id !== nextAddContentId)) {
      //  当移除nextAddContentId对应的node时
      input.forEach((item, index, array) => {
        if (item.id === addContentId) {
          setNextAddContentId(array[index + 1]?.id || WITHOUT_INPUT_ID);
        }
      });
    }
  }, [
    saasUIData,
    addContentId,
    nextAddContentId,
    isAddInputNode,
    setAddContentId,
    setIsClickAddToContent,
    setNextAddContentId,
  ]);

  return (
    <SortableList
      animation
      listType="input"
      options={sortableList}
      onChange={onChangeSaasUIInputData}
      renderItemChildren={({ index, value }) => {
        return (
          <>
            <AISaasInputItem key={value.id} x={value} index={index} isShare={false} />
          </>
        );
      }}
    />
  );
}
